var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCheckoutAsClient)?_c('div',{staticClass:"header-user-type"},[_c('UserType',{attrs:{"reload-page":""}}),(_vm.isManager)?_c('UserSelectedShop'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }